import { type ReactNode } from 'react'
import { type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * EmptyState — пустое состояние (`.stub` макета): центрированные иконка, заголовок, текст и
 * необязательное действие при отсутствии данных. Цвета/отступы из токенов.
 */
export interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon: Glyph, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-5 py-20 text-center text-txt-secondary',
        className,
      )}
    >
      {Glyph ? (
        <Glyph className="mb-4 size-12 stroke-current text-line-strong" strokeWidth={1.4} aria-hidden />
      ) : null}
      <p className="font-medium text-txt">{title}</p>
      {description ? <p className="mt-1 text-txt-secondary">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
